import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import About from "@/pages/About";

export const Route = createFileRoute("/about")({
  head: () => seoHead("/about"),
  component: About,
});
